














import {i18nMixin} from '@/modules/neodash/mixins';
import {IKeyValues} from '@/interfaces/key-value-interface';
import {Component, Prop, Vue} from 'vue-property-decorator';
import ReportAppBar from '@/modules/neodash/components/report-app-bar/report-app-bar.vue';
import BigIconPanel from '@/modules/neodash/components/big-icon-panel/big-icon-panel.vue';
import ReportPlaceHolder from '@/modules/neodash/components/report-placeholder/report.placeholder.vue';

@Component({
  name: 'ReportViewerContainer',
  components: {
    ReportPlaceHolder,
    BigIconPanel,
    ReportAppBar
  }
})
export default class ReportViewerContainer extends Vue {
  public readonly translate = i18nMixin.methods.i18n;

  @Prop({required: true})
  keyNameReport: string;

  @Prop({required: true})
  labelFilters: IKeyValues;

  @Prop({required: true})
  url: string;
}
